import React from "react";
import * as Icons from "lucide-react";
import { aboutCards, heroImages } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function About() {
  const { ref, inView } = useReveal();

  return (
    <section id="about" className="relative bg-background py-24">
      <div className="max-w-7xl mx-auto px-5">
        <div ref={ref} className={`reveal ${inView ? "in-view" : ""}`}>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-gold" />
            <span className="section-label text-gold text-xs">About the Club</span>
          </div>
          <h2 className="display-font uppercase text-white text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[0.95]">
            A club culture that <span className="text-gold">means something.</span>
          </h2>
          <p className="mt-6 text-white/70 text-lg max-w-2xl font-light">
            We are building more than a team. Atlético South Florida is a competitive young adult
            program built to unite the community and create a platform where talent, ambition and
            real opportunity come together.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-14">
          {aboutCards.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Circle;
            return (
              <div
                key={c.title}
                className="group relative bg-card border border-white/10 rounded-lg p-8 overflow-hidden hover:border-gold/50 transition-colors duration-300"
              >
                <div className="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-gold/5 group-hover:bg-gold/10 transition-colors" />
                <div className="relative">
                  <div className="w-14 h-14 rounded-md bg-gold/15 border border-gold/30 flex items-center justify-center text-gold mb-6 group-hover:scale-110 transition-transform">
                    <Icon size={26} />
                  </div>
                  <h3 className="cond-font uppercase tracking-wide text-xl text-white mb-3">{c.title}</h3>
                  <p className="text-white/60 font-light leading-relaxed">{c.body}</p>
                </div>
                <div className="display-font text-6xl text-white/5 absolute bottom-2 right-4">0{i + 1}</div>
              </div>
            );
          })}
        </div>

        {/* Mission strip */}
        <div className="relative mt-16 rounded-xl overflow-hidden border border-white/10">
          <img src={heroImages.stadium} alt="stadium" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/75" />
          <div className="relative p-10 lg:p-14">
            <span className="section-label text-gold text-xs">Club Mission</span>
            <h3 className="display-font uppercase text-white text-3xl sm:text-4xl mt-4 max-w-3xl leading-tight">
              Discipline. Identity. <span className="text-gold">Opportunity.</span>
            </h3>
            <p className="mt-5 text-white/70 max-w-2xl font-light text-lg">
              Atlético South Florida exists to provide a serious, competitive platform where
              young adults can sharpen their technical ability, compete at a high level, and earn
              their pathway to college and professional football.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
